<template>
    <div class='xbjl' v-if='kbxmlc'>
        <div :class='["box",kbxmlc.zt=="2"||role!="Z"?"noBtn":""]'>
            <div class='clear' v-if='role=="Z"'>
                <el-button type="primary rt" @click="dzxd" :disabled="isEdit">电子宣读<i class="el-icon-dzxd el-icon--right"></i></el-button>
                <el-button @click='handlePause' type="primary rt" style="margin-right:10px" v-if='isStart'>
                    <template v-if='isStop'>继续</template>
                    <template v-else>暂停</template>
                </el-button>
                <el-button type="primary rt" style="margin-right:10px" @click='editJl' v-show='!isEdit' :disabled="isStart">编辑</el-button>
                <el-button type="primary rt" style="margin-right:10px" @click='saveJl' v-show='isEdit'>保存</el-button>
            </div>
            <VueUeditorWrap v-show='isEdit' v-model='hcjlHtml' :config="editorConfig" class='jlContent'></VueUeditorWrap>
            <div class='jlContent' v-show='!isEdit' v-html='hcjlHtml'></div>
        </div>
        
        <el-button type='primary lcNext' @click='nextBtn' v-if='kbxmlc.zt!="2"&&role=="Z"' :disabled="waitLoading">下一步</el-button>
        <!-- 设置 -->
        <el-dialog title="电子宣读" :visible.sync="dialogFormVisible" width='600px' :close-on-click-modal="false">
            <el-form :model="form" label-width="70px">
                <el-form-item label="音量">
                    <el-radio-group v-model="form.volume">
                        <el-radio :label="0.2">低</el-radio>
                        <el-radio :label="0.4">中</el-radio>
                        <el-radio :label="0.6">高</el-radio>
                        <el-radio :label="0.8">很高</el-radio>
                        <el-radio :label="1">最高</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="语速">
                    <el-radio-group v-model="form.rate">
                        <el-radio :label="0.75">0.75x</el-radio>
                        <el-radio :label="1">1.0X</el-radio>
                        <el-radio :label="1.25">1.25X</el-radio>
                        <el-radio :label="1.5">1.5X</el-radio>
                        <el-radio :label="2">2.0X</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
           <div class="btnBox">
               <el-button type="primary" @click="handleSpeak">确定</el-button>
           </div>
        </el-dialog>
    </div>
    <div v-else class='loading'>
        <p>页面正在加载中...</p>
        <div id="colorfulPulse">
            <span class='item-1'></span>
            <span class='item-2'></span>
            <span class='item-3'></span>
            <span class='item-4'></span>
            <span class='item-5'></span>
            <span class='item-6'></span>
            <span class='item-7'></span>
        </div>
    </div>
</template>
<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
    name:'xbjl',
    components:{
        VueUeditorWrap
    },
    data(){
        return{
            waitLoading:false,
            kbxmlc:'',
            djlcId:'',
            hcjlHtml:'',//会场纪律
            hcjl:'',
            synth:'',//对象
            msg:'',//实例
            dialogFormVisible:false,
            form:{
                volume:1,
                rate:1,
            },
            isStop:false,//是否暂停状态
            isStart:false,//是否开始电声
            role:localStorage.getItem('role')?localStorage.getItem('role'):'T',
            isEdit:false,//是否正在编辑
            editorConfig: {
                // 编辑器是否自动被内容撑高
                autoHeightEnabled: false,
                // 初始容器高度
                initialFrameHeight: '100%',
                // 初始容器宽度
                initialFrameWidth: '100%',
                // 调试完毕打包上线则切换回/static/UEditor/php/controller.php即可，不用做其他处理
                serverUrl:'/api/v2/ueditor/ueditorConfig',
                UEDITOR_HOME_URL: "/UEditor/", //UEditor资源文件的存放路径
                zIndex:9999,
                toolbars:[['bold',]],
                wordCount:false
            },
        }
    },
    methods:{
        getData(){
            let para={
                djlcId:this.djlcId,
            }
            this.$api.kbhcjl(para).then(res=>{
                if(res.data.meta.success){
                    this.hcjlHtml=res.data.data.hcjl;
                    this.hcjl=res.data.data.hcjlcwb;
                    this.kbxmlc=res.data.data.kbxmlc;
                    if(!('speechSynthesis' in window)) {
                        if(this.kbxmlc.zt!="2"){
                            this.$message({
                                type:'error',
                                message:'对不起，您的浏览器不支持电子宣读功能，请更换急速模式或者谷歌浏览器'
                            })
                        }
                    }else{
                        this.msg=null;
                        this.synth=window.speechSynthesis;
                        this.synth.speak(new SpeechSynthesisUtterance(''));
                        this.init();
                    }
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
            }).catch(()=>{})
            
        },
        dzxd(){
            if(!('speechSynthesis' in window)) {
                this.$message({
                    type:'error',
                    message:'对不起，您的浏览器不支持此功能，请更换急速模式或者谷歌浏览器'
                })
		    }else{
                this.dialogFormVisible=true;
            }
        },
        editJl(){
            this.isEdit=true;
        },
        saveJl(){
            let para={
                hcjl:this.hcjlHtml
            }
            this.waitLoading=true
            this.$api.saveKbhcjl(para).then(res=>{
                if(res.data.meta.success){
                    this.isEdit=false;
                    this.hcjl=res.data.data.hcjlcwb;
                    this.$message({
                        type:'success',
                        message:'保存成功！'
                    })
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
                this.waitLoading=false
            }).catch(()=>{})
        },
        nextBtn(){
            if(this.isStart){
                this.$confirm('请确认是否结束电子宣读，并进入下一步！', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let para={
                        falg:this.kbxmlc.ycdz
                    }
                    this.waitLoading=true
                    this.$emit('nextBtn',para)
                }).catch(() => {
                            
                });
            }else{
                let para={
                    falg:this.kbxmlc.ycdz
                }
                this.waitLoading=true
                this.$emit('nextBtn',para)
            }
        },
        handleSpeak(){
            this.synth.cancel(this.msg);
            this.msg.text = this.hcjl;//文本
            this.msg.lang = 'zh-CN';
            this.msg.volume = this.form.volume;//声音的音量，区间范围是0到1，默认是1
            this.msg.rate = this.form.rate;//语速
            this.msg.pitch = 1;//音调高低
            this.synth.speak(this.msg);
            this.dialogFormVisible=false;
            this.isStop=false
            this.setPlayerVolume(0)

            // 播报完成
            this.synth.onend = () => {
                console.log('语音播放已完成')
                this.setPlayerVolume(1)
            };
        },
        // 语音暂停
        handlePause(){
            if(this.isStop){
                this.synth.resume();
                this.isStop=false;
                this.setPlayerVolume(0)
            }else{
                //暂停
                this.synth.pause();
                this.isStop=true
                this.setPlayerVolume(1)
            }
            //播放
            //window.speechSynthesis.speak();
            //继续
           // window.speechSynthesis.resume();
            //停止
            //window.speechSynthesis.cancel();
        },
        init(){
            
            this.msg = new SpeechSynthesisUtterance();
            let _this=this
            this.msg.onend=function(){
                _this.isStart=false;
            };
            this.msg.onstart=function(){
                _this.isStart=true;
            }
        },
        setPlayerVolume(volume) {
            const win = document.getElementById("sharePlayer").contentWindow
            if (!win) return
            console.log('发送消息', { type: "sharePlayer", action: 'volume', data: volume })
            win.postMessage(
                { type: "sharePlayer", action: 'volume', data: volume },
                "*"
            );
        }
    },
    mounted(){
        this.djlcId = this.$route.query.djlcId;
        this.getData();
    },
    destroyed(){
        if('speechSynthesis' in window) {
            this.msg=null;
            this.synth.cancel(this.msg);
        }
    }
}
</script>
<style lang="less" scope>
    .xbjl{
        .el-icon-dzxd{
            width:17px;
            height:15px;
            background: url('../assets/images/lb.jpg') no-repeat center;
            position: relative;
            top:2px;
        }
        .el-radio{
            width: 70px;
        }
        .jlContent{
            margin-top:10px;
            height:calc(~'100% - 60px');
            overflow-y: auto;
            >.edui-default{
                height:100%;
                >.edui-default.edui-editor{
                    height:100%;
                }
            }
            .edui-default .edui-editor-iframeholder{
                height:calc(~ '100% - 60px') !important;
            }
        }
    }
</style>